import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterLink } from '@angular/router';

import {
    UiCardContentDirective,
    UiCardDirective,
    UiCardHeaderDirective,
    UiCardTitleDirective,
    UILabelComponent,
    UILogoComponent,
    UISVGIconComponent
} from '@bannerflow/ui';

@Component({
    selector: 'app-menu',
    templateUrl: './menu.component.html',
    styleUrls: ['./menu.component.scss'],
    imports: [
        RouterLink,
        UILogoComponent,
        UISVGIconComponent,
        UILabelComponent,
        UiCardDirective,
        UiCardHeaderDirective,
        UiCardContentDirective,
        UiCardTitleDirective
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: true
})
export class MenuComponent {}
